// extracted by css-extract-rspack-plugin
export default {"userColumn":"otVqRdk4akYgztTy","info":"s2fmSjlC_EGn860Z","name":"o0yq4UZ8OpgCtrK3","userHeading":"EaUrRmW5J4w8UovZ"};